"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCloudinaryPicture = exports.InstructionRowStatic = exports.InstructionRowLink = exports.HeadingWrapper = exports.ContentWrapper = exports.Chevron = exports.ChecklistIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _vars = require("../../styles/vars");
var _CloudinaryPicture = _interopRequireDefault(require("../CloudinaryPicture"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Link = _interopRequireDefault(require("../Link"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
//helpers

//components

var InstructionRowStatic = exports.InstructionRowStatic = _styledComponents["default"].div.withConfig({
  displayName: "styles__InstructionRowStatic",
  componentId: "sc-1cu2qjb-0"
})(["align-items:center;background:#fff;display:flex;padding:0.5rem;", ""], function (p) {
  return p.device === 'desktop' && "\n    ".concat((0, _vars.cardShadowCss)(p.isLink), "\n    border-radius: ").concat(_vars.borderRadius.desktop, "px;\n  ");
});
var InstructionRowLink = exports.InstructionRowLink = InstructionRowStatic.withComponent(_Link["default"]);
var StyledCloudinaryPicture = exports.StyledCloudinaryPicture = (0, _styledComponents["default"])(_CloudinaryPicture["default"]).attrs({
  aspectRatio: 4 / 3,
  sizes: '84px'
}).withConfig({
  displayName: "styles__StyledCloudinaryPicture",
  componentId: "sc-1cu2qjb-1"
})(["flex-shrink:0;width:84px;"]);
var ContentWrapper = exports.ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-1cu2qjb-2"
})(["flex-grow:1;margin-left:1rem;overflow:hidden;"]);
var Chevron = exports.Chevron = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'chevron-right'
}).withConfig({
  displayName: "styles__Chevron",
  componentId: "sc-1cu2qjb-3"
})(["display:block;flex-shrink:0;margin-left:1rem;opacity:0.2;"]);
var HeadingWrapper = exports.HeadingWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__HeadingWrapper",
  componentId: "sc-1cu2qjb-4"
})(["display:flex;"]);
var ChecklistIcon = exports.ChecklistIcon = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'checklist',
  size: 26
}).withConfig({
  displayName: "styles__ChecklistIcon",
  componentId: "sc-1cu2qjb-5"
})(["margin:0 8px 0 -8px;"]);
//# sourceMappingURL=styles.js.map